// api
export const API_PLATFORM_VERSIONS = '/config/edgePlatformVersions';
export const API_PLATFORM_VERSION_ITEM = `${API_PLATFORM_VERSIONS}/:id`;

// redux
export const PLATFORM_VERSIONS_STORE = 'platformVersions';
export const PLATFORM_VERSIONS_STORE_LIST = 'list';
